import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { PageContext } from '@contexts/PageContext';

const getCurrentBreadCrumbTrail = (activeUrl) => {
  const urlSegments = activeUrl.split('/').filter((segment) => segment !== '');

  const breadCrumbs = [];

  for (let i = 0; i < urlSegments.length; i++) {
    const breadCrumbParts = [];
    for (let x = 0; x <= i; x++) {
      breadCrumbParts.push(urlSegments[x]);
    }
    breadCrumbs.push({ url: `/${breadCrumbParts.join('/')}`, value: urlSegments[i] });
  }
  return breadCrumbs;
};

const findUrlOrValue = (currentSite, breadCrumbData, breadCrumb) => {
  let key;
  let value;

  Object.entries(breadCrumbData).forEach(([keyBreadCrumbData, valueBreadCrumbData]) => {
    if (
      (valueBreadCrumbData.toLowerCase() === breadCrumb.value.toLowerCase() ||
        keyBreadCrumbData.toLowerCase() === breadCrumb.url.toLowerCase()) &&
      keyBreadCrumbData.startsWith(currentSite?.toLowerCase())
    ) {
      key = keyBreadCrumbData;
      value = valueBreadCrumbData;
      return;
    }
  });

  if (!key || !value) return undefined;
  return { key, value };
};

export default function Breadcrumb({ activeURL }) {
  const { breadCrumbData } = useContext(PageContext);

  const breadCrumbTrail = getCurrentBreadCrumbTrail(activeURL);

  return (
    breadCrumbTrail.length > 1 && (
      <nav aria-label="breadcrumbs">
        <ou-breadcrumb breadcrumb-label="Breadcrumb">
          {breadCrumbTrail.map((breadCrumb, index) => {
            const currentSite = `/${breadCrumbTrail[0].value}`;
            const breadCrumbItem = findUrlOrValue(currentSite, breadCrumbData, breadCrumb);
            if (!breadCrumbItem) return null;
            const { key, value } = breadCrumbItem;

            return (
              key !== undefined &&
              value !== undefined && (
                <ou-breadcrumb-item
                  key={key}
                  href={key}
                  text={value}
                  accessible-text={value}
                  is-current-page={index === breadCrumbTrail.length - 1 ? 'true' : undefined}
                />
              )
            );
          })}
        </ou-breadcrumb>
      </nav>
    )
  );
}

Breadcrumb.propTypes = {
  activeURL: PropTypes.string,
};
